import { getLocale } from 'redux-polyglot';
import { API_URL, API_VERSION } from '../browser/browserConfig';

export function getApiUrl(state, resource) {
	const currentLocale = getLocale(state);
	return `${API_URL}${API_VERSION}/${currentLocale}/${resource}`;
}